import { present } from 'shared/presenters/presenter'
import { Redemption_Codes } from 'shared/presenters/graphqlTypes'

export class RedemptionCodePresenter extends present<Redemption_Codes>() {}
